import { featureData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择黑料网站
          </h2>
          <p className="text-sm text-foreground-500 mt-1">千万吃瓜群众的共同选择</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featureData.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-100 rounded-xl p-6 md:p-8 text-center border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-2xl md:text-3xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}